import { createFocusTrap } from '@theme/utils';

class Header extends HTMLElement {
  constructor() {
    super();

    this.menuTrigger = this.querySelector('[js-site-header="trigger"]');
    this.mobileMenu = document.querySelector('[js-site-header="mobile-menu"]');
    this.toggleMobileMenu = this.toggleMobileMenu.bind(this);

    if (this.mobileMenu) {
      this.focusTrap = createFocusTrap(this.mobileMenu);
    }
  }

  connectedCallback() {
    this.menuTrigger.addEventListener("click", this.toggleMobileMenu);

    // Set initial state (closed by default)
    if (this.mobileMenu) {
      this.updateMenuTabindex(false);
    }
  }

  disconnectedCallback() {
    this.menuTrigger.removeEventListener("click", this.toggleMobileMenu);
    if (this.focusTrap) {
      this.focusTrap.disable();
    }
  }

  toggleMobileMenu() {
    const isActive = this.mobileMenu.hasAttribute("data-active");
    this.mobileMenu.toggleAttribute("data-active");
    this.menuTrigger.toggleAttribute("data-active");

    // Update tabindex based on new state
    this.updateMenuTabindex(!isActive);

    // Enable/disable focus trap
    if (!isActive && this.mobileMenu) {
      this.focusTrap.enable();

      // When opening, focus first focusable element for accessibility
      const firstFocusable = this.mobileMenu.querySelector('a, button');
      if (firstFocusable) {
        setTimeout(() => {
          firstFocusable.focus();
        }, 0);
      }
    } else {
      this.focusTrap.disable();
    }
  }

  updateMenuTabindex(isOpen) {
    if (!this.mobileMenu) return;

    // Find all focusable elements inside the menu
    const focusableSelectors = [
      'a[href]',
      'button:not([disabled])',
      'input:not([disabled])',
      'select:not([disabled])',
      'textarea:not([disabled])',
      '[tabindex]:not([tabindex="-1"])'
    ].join(', ');

    const focusableElements = this.mobileMenu.querySelectorAll(focusableSelectors);

    focusableElements.forEach(element => {
      if (isOpen) {
        // Restore natural tabindex when open
        if (element.dataset.savedTabindex !== undefined) {
          element.tabIndex = parseInt(element.dataset.savedTabindex, 10);
          delete element.dataset.savedTabindex;
        } else if (element.hasAttribute('tabindex')) {
          element.removeAttribute('tabindex');
        }
      } else {
        // Save current tabindex and set to -1 when closed
        if (element.hasAttribute('tabindex')) {
          element.dataset.savedTabindex = element.tabIndex;
        }
        element.tabIndex = -1;
      }
    });
  }
}



window.customElements.define("site-header", Header);
